import { makeApiUrl, makeHttpClient } from '../../http';
import { ListDetailedTeleShifts as UsecaseRemoteListDetailedShifts } from '~/domain/usecases/teleShifts/remote';
import { RemoteListDetailedShifts } from '~/data/repository/teleShifts';

export const makeRemoteListDetailedShifts = (): UsecaseRemoteListDetailedShifts =>
  new RemoteListDetailedShifts(
    makeApiUrl('/shifts/list/detailed'),
    makeHttpClient()
  );
